import { SlidersHorizontal } from "lucide-react";
import SortDropdown from "@/theme1/components/shop/SortDropdown";
import ResultsSummary from "@/theme1/components/shop/ResultsSummary";

export default function ProductToolbar({
  total,
  search,
  sort,
  onSortChange,
  onOpenFilters,
  onSearchChange,
}) {
  return (
    <div className="sticky top-4 z-20 rounded-[1.5rem] border border-border/60 bg-white/80 p-4 shadow-lg shadow-black/5 backdrop-blur-xl">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <ResultsSummary total={total} search={search} />

        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <input
            type="search"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search products"
            aria-label="Search products"
            className="rounded-full border border-border bg-white px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />

          <SortDropdown value={sort} onChange={onSortChange} />

          <button
            type="button"
            onClick={onOpenFilters}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-border bg-white px-4 py-2 text-sm font-medium lg:hidden"
          >
            <SlidersHorizontal className="size-4" />
            Filters
          </button>
        </div>
      </div>
    </div>
  );
}